import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import logo from '../assets/logoText.svg';

const styles = {
	header: {
		padding: '20px',
	  textAlign: 'left',
	}, 
	logoContainer: {
		flex: 1,
	  height: '25px',
	  paddingLeft: '24px',
	  paddingRight: '20px',  
	  justify: 'left',
	},
	logo: {
		maxWidth: '336px',
		maxHeight: '25px',
		textAlign: 'left',
	},
	logoMobile: {
		maxWidth: '269px',
		maxHeight: '20px',
	},
	menu: {
		textAlign: 'right',
	},
	menuMobile: {
		marginTop: 15,
	},
};

class Header extends React.Component {

  render() {
    const { classes } = this.props;

    return (
    	<AppBar id='header' position='static' color='white' className={classes.header}>
    		<Grid container justify="space-between" alignItems='center' spacing={0}>
			    <Hidden smUp>
            <Grid container justify="space-between" alignItems='center' spacing={0}>
              <Grid item xs={12} className={classes.logoContainer} align='center'>
                <a href='/home'><img src={logo} alt='logo' className={classes.logoMobile}/></a>
              </Grid>
              <Grid item xs={12} className={classes.menuMobile} align='center'>
                <a href='/funding' className='menuItem'>Funding</a>
                <br />
                <a href='/applications' className='menuItem'>Applications</a>
                <br />
                <a href='/leadership' className='menuItem'>Leadership</a>
                <br />
                <a href='/testimonials' className='menuItem'>Testimonials</a>
                <br />
                <a href='/contact' className='menuItem'>Contact</a>
              </Grid>
            </Grid>
          </Hidden>
			    <Hidden xsDown>
            <Grid container justify="space-between" alignItems='center' spacing={0}>
              <Grid item xs={12} className={classes.logoContainer} align='center'>
                <a href='/home'><img src={logo} alt='logo' className={classes.logoMobile}/></a>
              </Grid>
              <Grid item xs={12} className={classes.menuMobile} align='center'>
                <a href='/funding' className='menuItem'>Funding</a>
                <a href='/applications' className='menuItem'>Applications</a>
                <a href='/leadership' className='menuItem'>Leadership</a>
                <a href='/testimonials' className='menuItem'>Testimonials</a>
                <a href='/contact' className='menuItem'>Contact</a>
              </Grid>
            </Grid>
	        </Hidden>
			  </Grid>
		  </AppBar>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js